
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11 11.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 4.8v2H6.6v4.8H4.4V6.8H0v-2h4.4V0h2.2v4.8H11z","fill":"#c22292"}})])
          )
        }
      }
    